module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-x-0",
    class: _vm.setting.class,
    attrs: {
      "id": _vm.setting.id
    }
  }, [_c('div', {
    staticClass: "j-mutiple-left"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "from",
      "id": "multiselect",
      "size": "8"
    }
  }, _vm._l((_vm.setting.options), function(option, index) {
    return _c('option', {
      class: 'o-' + option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-middle"
  }, [_c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_rightSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    attrs: {
      "type": "button",
      "id": 'multiselect_leftSelected-' + _vm.setting.class
    },
    on: {
      "click": function($event) {
        _vm.isChoose = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "j-mutiple-right"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "to",
      "id": 'multiselect_to-' + _vm.setting.class,
      "size": "8",
      "multiple": "multiple"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('p', {
    staticClass: "text-12"
  }, [_vm._v("已選 " + _vm._s(this.setting.choose.length) + " 間")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75083018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/jMutiSelect_v2.vue
// module id = 2481
// module chunks = 1